<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Pending Registrations
            <v-spacer></v-spacer>
            <ReturnHomeBtn />
          </v-card-title>
          <v-data-table
            :loading="!pendingAccounts"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="pendingAccounts"
            :expanded.sync="expanded"
            show-expand
          >
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">Address: {{ item.addressLine }}</td>
            </template>
            <template v-slot:item.expiryDate="{ item }">{{ item.expiryDate | formatDate }}</template>

            <template v-slot:item.actions="{ item }">
              <v-layout :justify-end="true">
                <v-icon class="mr-2" @click.stop="confirmItem(item)">mdi-account-check</v-icon>

                <v-icon class="mr-2" @click="deleteItem(item)">mdi-delete</v-icon>
              </v-layout>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { errorMessageMixin } from "../shared";
import ReturnHomeBtn from "../components/ReturnHomeBtn.vue";

export default {
  name: "PendingAccounts",
  mixins: [errorMessageMixin],
  components: { ReturnHomeBtn },
  async created() {
    await this.loadPendingAccounts();
  },
  computed: {
    ...mapState(["pendingAccounts"])
  },
  data() {
    return {
      headers: [
        { text: "First Name", value: "firstName", align: "start" },
        { text: "Last Name", value: "lastName" },
        { text: "Email Address", value: "emailAddress" },
        { text: "Phone Number", value: "phoneNumber" },
        { text: "Expiry Date", value: "expiryDate" },
        { text: "", value: "data-table-expand" },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          align: "end"
        }
      ],
      expanded: []
    };
  },
  methods: {
    ...mapActions([
      "getPendingAccountsAction",
      "deletePendingAccountAction",
      "confirmPendingAccountAction"
    ]),
    async loadPendingAccounts() {
      try {
        await this.getPendingAccountsAction();
        if (this.$store.state.pendingAccounts == null) {
          console.log("go home");
          this.$router.push({
            name: "Home",
            params: { msg: "No pending account registrations." }
          });
        }
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
    },
    async confirmItem(item) {
      if (
        confirm(
          "Confirm " +
            item.firstName +
            " " +
            item.lastName +
            " email:" +
            item.emailAddress +
            " entry?"
        )
      ) {
        console.log("confirm");
        this.$store.state.fullScreenLoading = true;
        const confirmPendingAccountModel = {
          pendingAccountId: item.id,
          unlockKey: item.unlockKey
        };
        try {
          await this.confirmPendingAccountAction({
            model: confirmPendingAccountModel,
            token: this.$store.state.token
          });
          // write a message
          console.log("confirm done");
        } catch (err) {
          console.log("im in error", err);
          this.$store.state.error = this.errorMessage(err);
          this.$store.state.snackbar = true;
          console.log(err);
        }
        this.$store.state.fullScreenLoading = false;
      }
    },
    async deleteItem(item) {
      if (
        confirm("Delete " + item.firstName + " " + item.lastName + " entry?")
      ) {
        this.$store.state.fullScreenLoading = true;
        const deletePendingAccountModel = {
          pendingAccountId: item.id
        };
        try {
          await this.deletePendingAccountAction({
            model: deletePendingAccountModel,
            token: this.$store.state.token
          });
          // write a message
          console.log("delete done");
        } catch (err) {
          console.log("im in error");
          this.$store.state.error = this.errorMessage(err);
          this.$store.state.snackbar = true;
          console.log(err);
        }
        this.$store.state.fullScreenLoading = false;
      }
    }
  }
};
</script>